import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { State } from '@/types';
import { emptyStringValues } from '@/utils/objects';

import { ChannelRecordingType } from '../types';

import { channelRecordingsQueryKeys } from './query-keys';

export type TPatchChannelRecordingSchedule = {
  repetition_day_of_week?: string | null;
  start_hour: string;
  end_hour: string;
};

export type TPatchChanelRecordingParams = {
  id: string;
  state: State;
  start_datetime: string | Date;
  segment_duration: number;
  channel_id: string;
  description?: string | null;
  end_datetime?: string | Date | null;
  production_centers: string[];
  schedule: TPatchChannelRecordingSchedule[];
};

export async function patchChannelRecording(
  params: TPatchChanelRecordingParams
): Promise<ChannelRecordingType> {
  return mediaManagerClient.patch(
    `/api/v1/channel_recordings/${params.id}`,
    emptyStringValues(params)
  );
}

type MutationFn = typeof patchChannelRecording;

type TUsePatchChannelRecordingParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchChannelRecording({ config = {} }: TUsePatchChannelRecordingParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchChannelRecording,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la grabación'));
      console.error(error);
    },
    onSuccess(channelRecording, variables, context) {
      addSuccessNotification(t('La grabación se ha actualizado correctamente'));
      queryClient.invalidateQueries({ queryKey: channelRecordingsQueryKeys.all });
      config.onSuccess?.(channelRecording, variables, context);
    },
  });
}
